module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container quotation-container"
  }, [(this.turn_to_pdf == true) ? _c('div', {
    staticClass: "loading-over"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isPresent(_vm.quotation)) ? _c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('button', {
    staticClass: "btn btn-default primary-btn",
    on: {
      "click": function($event) {
        _vm.GoDeal(_vm.quotation.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-circle-arrow-left"
  }), _vm._v(" 返回")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default primary-btn",
    attrs: {
      "href": _vm.axios.defaults.baseURL + '/pdf_generators/quotation.html?quotation_token=' + _vm.quotation.quotation_token,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 預覽")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default primary-btn",
    attrs: {
      "href": _vm.axios.defaults.baseURL + '/pdf_generators/quotation.pdf?quotation_token=' + _vm.quotation.quotation_token + '&v=' + Math.random(),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 預覽PDF")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default primary-btn pull-right",
    on: {
      "click": function($event) {
        _vm.turnToPdf()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" 完成報價單，及轉存PDF")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default primary-btn pull-right mr10",
    on: {
      "click": function($event) {
        _vm.SettingModal = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default primary-btn pull-right mr10",
    on: {
      "click": function($event) {
        _vm.syncQuotationAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), (_vm.updating == false) ? _c('span', {
    staticClass: "pull-right save-time mr10"
  }, [_vm._v("自動儲存：" + _vm._s(_vm._f("moment")(_vm.quotation.updated_at, "YYYY-MM-DD, h:mm:ss a")))]) : _c('span', {
    staticClass: "pull-right save-time mr10"
  }, [_vm._v("自動儲存中....")])]) : _vm._e(), _vm._v(" "), (_vm.isPresent(_vm.quotation)) ? _c('div', {
    staticClass: "quotation"
  }, [_c('div', {
    staticClass: "quotation-header"
  }, [_c('div', {
    staticClass: "company_info text-left"
  }, [(_vm.quotation.logo == '') ? _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": "/static/logo-default.jpg"
    },
    on: {
      "click": function($event) {
        _vm.SettingModal = true
      }
    }
  }) : _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": _vm.quotation.logo
    },
    on: {
      "click": function($event) {
        _vm.SettingModal = true
      }
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin": "0px"
    }
  }, [(_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_company_name') ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_company_name', _vm.quotation.sales_information.company_name)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.company_name)) ? _c('b', [_vm._v("本公司名稱")]) : _c('b', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.company_name))])]) : _vm._e(), _vm._v(" "), (_vm.quotation.edit == 'sales_information_company_name') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_company_name",
    staticClass: "full-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.company_name = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "quotation_info"
  }, [_c('table', {
    staticClass: "table text-center table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_date'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_date'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_date', _vm.quotation.quotation_information.date)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.quotation_information.date)) ? _c('span', [_vm._v("報價日期")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.quotation_information.date))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'quotation_information_date'),
      expression: "quotation.edit=='quotation_information_date'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "quotation_information_date",
    staticClass: "full-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.quotation_information.date = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_number'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_number'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_number', _vm.quotation.quotation_information.number)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.quotation_information.number)) ? _c('span', [_vm._v("報價單號")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.quotation_information.number))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'quotation_information_number'),
      expression: "quotation.edit=='quotation_information_number'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "quotation_information_number",
    staticClass: "full-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.quotation_information.number = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td')])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  }), _vm._v(" "), _c('div', {
    staticClass: "client_info text-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "pointer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'client_information_name'),
      expression: "quotation.edit=='no' || quotation.edit!='client_information_name'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('client_information_name', _vm.quotation.client_information.name)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.client_information.name)) ? _c('span', [_vm._v("客戶姓名")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.client_information.name))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'client_information_name'),
      expression: "quotation.edit=='client_information_name'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "client_information_name",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.client_information.name = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'client_information_phone'),
      expression: "quotation.edit=='no' || quotation.edit!='client_information_phone'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('client_information_phone', _vm.quotation.client_information.phone)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.client_information.phone)) ? _c('span', [_vm._v("客戶電話")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.client_information.phone))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'client_information_phone'),
      expression: "quotation.edit=='client_information_phone'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "client_information_phone",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.client_information.phone = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pointer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'client_information_email'),
      expression: "quotation.edit=='no' || quotation.edit!='client_information_email'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('client_information_email', _vm.quotation.client_information.email)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.client_information.email)) ? _c('span', [_vm._v("客戶Email")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.client_information.email))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'client_information_email'),
      expression: "quotation.edit=='client_information_email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "client_information_email",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.client_information.email = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pointer"
  }, [(_vm.quotation.edit == 'no' || _vm.quotation.edit != 'client_information_company_name') ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('client_information_company_name', _vm.quotation.client_information.company_name)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.client_information.company_name)) ? _c('span', [_vm._v("客戶公司全名")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.client_information.company_name))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'client_information_company_name'),
      expression: "quotation.edit=='client_information_company_name'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "client_information_company_name",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.client_information.company_name = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pointer"
  }, [(_vm.quotation.edit == 'no' || _vm.quotation.edit != 'client_information_address') ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('client_information_address', _vm.quotation.client_information.address)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.client_information.address)) ? _c('span', [_vm._v("客戶公司地址")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.client_information.address))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'client_information_address'),
      expression: "quotation.edit=='client_information_address'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "client_information_address",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.client_information.address = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sales_info"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_name'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_name'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_name', _vm.quotation.sales_information.name)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.name)) ? _c('span', [_vm._v("業務姓名")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.name))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_name'),
      expression: "quotation.edit=='sales_information_name'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_name",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.name = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_position'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_position'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_position', _vm.quotation.sales_information.position)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.position)) ? _c('span', [_vm._v("職位")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.position))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_position'),
      expression: "quotation.edit=='sales_information_position'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_position",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.position = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_phone'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_phone'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_phone', _vm.quotation.sales_information.phone)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.phone)) ? _c('span', [_vm._v("聯絡電話")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.phone))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_phone'),
      expression: "quotation.edit=='sales_information_phone'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_phone",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.phone = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_email'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_email'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_email', _vm.quotation.sales_information.email)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.email)) ? _c('span', [_vm._v("Email")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.email))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_email'),
      expression: "quotation.edit=='sales_information_email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_email",
    staticClass: "full-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.email = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_company_number'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_company_number'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_company_number', _vm.quotation.sales_information.company_number)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.company_number)) ? _c('span', [_vm._v("統一編號：無")]) : _c('span', [_vm._v("統一編號：" + _vm._s(_vm.quotation.sales_information.company_number))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_company_number'),
      expression: "quotation.edit=='sales_information_company_number'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_company_number",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.company_number = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'sales_information_address'),
      expression: "quotation.edit=='no' || quotation.edit!='sales_information_address'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('sales_information_address', _vm.quotation.sales_information.address)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.sales_information.address)) ? _c('span', [_vm._v("公司地址")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.sales_information.address))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'sales_information_address'),
      expression: "quotation.edit=='sales_information_address'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "sales_information_address",
    staticClass: "full-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.sales_information.address = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  })]), _vm._v(" "), _c('div', {
    staticClass: "quotation-content"
  }, [_c('h4', {
    staticClass: "quotation-title"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_title'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_title'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_title', _vm.quotation.quotation_information.title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.quotation_information.title)) ? _c('span', [_vm._v("報價單標題")]) : _c('span', [_vm._v(" " + _vm._s(_vm.quotation.quotation_information.title))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'quotation_information_title'),
      expression: "quotation.edit=='quotation_information_title'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "quotation_information_title",
    staticClass: "xlarge-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.quotation_information.title = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.quotation.quotation_information.hide_subtotal == true) ? _c('button', {
    staticClass: "btn btn-xs btn-default select_show_subtotal ",
    on: {
      "click": function($event) {
        _vm.quotation.quotation_information.hide_subtotal = false;
        _vm.syncQuotationAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  }), _vm._v(" 單價總價不顯示")]) : _c('button', {
    staticClass: "btn btn-xs btn-default select_show_subtotal active",
    on: {
      "click": function($event) {
        _vm.quotation.quotation_information.hide_subtotal = true;
        _vm.syncQuotationAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" 單價總價顯示")]), _vm._v(" "), _c('table', {
    staticClass: "quotation-table table",
    class: {
      'HideAllSubTotal': _vm.quotation.quotation_information.hide_subtotal
    },
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('thead', [_c('tr', {
    style: ({
      'background-color': _vm.quotation['quotation_information']['background_color1'].hex,
      'color': _vm.quotation['quotation_information']['color1'].hex,
    })
  }, [_c('th', {
    staticClass: "quotation_column1"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "quotation_column2"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "quotation_column3"
  }, [_vm._v("內容")]), _vm._v(" "), _c('th', {
    staticClass: "quotation_column4"
  }, [_vm._v("數量")]), _vm._v(" "), _c('th', {
    staticClass: "quotation_column5"
  }, [_vm._v("單價")]), _vm._v(" "), _c('th', {
    staticClass: "quotation_column6",
    staticStyle: {
      "border-right": "none !important"
    }
  }, [_vm._v("總價")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "6"
    }
  }, [(_vm.quotation.quotation_item_categories.length == 0) ? _c('div', {
    staticClass: "intro"
  }, [_c('h3', [_vm._v("沒有品項或分類，請從右側的項目區域，點擊加入新品項")])]) : _vm._e(), _vm._v(" "), _c('Container', {
    attrs: {
      "lock-axis": "y",
      "drop-placeholder": _vm.dropPlaceholderOptions
    },
    on: {
      "drop": function($event) {
        _vm.onListDrop($event)
      }
    }
  }, _vm._l((_vm.quotation.quotation_item_categories), function(quotation_item_category, indexPc) {
    return _c('Draggable', {
      key: quotation_item_category.id,
      staticClass: "item-lists",
      staticStyle: {
        "overflow": "initial"
      }
    }, [_c('div', {
      staticClass: "draggable_quotation_item_cateogry"
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_category_name' + quotation_item_category.id)),
        expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_category_name'+quotation_item_category.id)"
      }],
      staticClass: "pointer  mb0",
      on: {
        "click": function($event) {
          _vm.editTextClick(('quotation_item_category_name' + quotation_item_category.id), quotation_item_category.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    }), _vm._v(" "), (_vm.checkEmpty(quotation_item_category.name)) ? _c('span', [_vm._v("分類名稱")]) : _c('span', [_vm._v(_vm._s(quotation_item_category.name))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.quotation.edit == ('quotation_item_category_name' + quotation_item_category.id)),
        expression: "quotation.edit==('quotation_item_category_name'+quotation_item_category.id)"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.content_cache),
        expression: "content_cache"
      }],
      ref: ('quotation_item_category_name' + quotation_item_category.id),
      refInFor: true,
      staticClass: "large-input",
      attrs: {
        "tyle": "number"
      },
      domProps: {
        "value": (_vm.content_cache)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.quotation.edit = 'no';
          quotation_item_category.name = _vm.content_cache;
          quotation_item_category.product_category_id = '';
          _vm.UpdateCategory(quotation_item_category)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.content_cache = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "button-area"
    }, [_c('a', {
      staticClass: "row-edit pull-right",
      on: {
        "click": function($event) {
          _vm.delete_quotation_item_category = quotation_item_category;
          _vm.checkQuotationItemCategoryBeforeDelete(quotation_item_category)
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-close"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "dragArea full-width text-left "
    }, [_c('Container', {
      staticClass: "quotation_item_drag_area container-fluid move-pointer",
      attrs: {
        "group-name": "item",
        "get-child-payload": _vm.getCardPayload(quotation_item_category.id),
        "lock-axis": "y",
        "drop-placeholder": _vm.dropItemPlaceholderOptions
      },
      on: {
        "drop": function (e) { return _vm.onItemDrop(quotation_item_category.id, e); }
      }
    }, _vm._l((quotation_item_category.quotation_items), function(quotation_item, index) {
      return _c('Draggable', {
        key: quotation_item.id,
        staticClass: "draggable_quotation_item row",
        staticStyle: {
          "display": "flex",
          "overflow": "initial"
        }
      }, [_c('div', {
        staticClass: "quotation_column1"
      }, [_vm._v("\n\t                                  " + _vm._s(index + 1) + "\n\t                                ")]), _vm._v(" "), _c('div', {
        staticClass: "quotation_column2"
      }, [_c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_name' + quotation_item.id)),
          expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_name'+quotation_item.id)"
        }],
        staticClass: "pointer mb0",
        on: {
          "click": function($event) {
            _vm.editTextClick(('quotation_item_name' + quotation_item.id), quotation_item.name)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-alt"
      }), _vm._v(" "), (_vm.checkEmpty(quotation_item.name)) ? _c('span') : _c('span', [_vm._v(" " + _vm._s(quotation_item.name))])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == ('quotation_item_name' + quotation_item.id)),
          expression: "quotation.edit==('quotation_item_name'+quotation_item.id)"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.content_cache),
          expression: "content_cache"
        }],
        ref: ('quotation_item_name' + quotation_item.id),
        refInFor: true,
        staticClass: "full-input",
        domProps: {
          "value": (_vm.content_cache)
        },
        on: {
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            $event.target.blur()
          },
          "blur": function($event) {
            _vm.quotation.edit = 'no';
            quotation_item.name = _vm.content_cache;
            _vm.updateQuotationItem(quotation_item)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.content_cache = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "quotation_column3"
      }, [(quotation_item.description == null || quotation_item.description == '') ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_description' + quotation_item.id)),
          expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_description'+quotation_item.id)"
        }],
        staticClass: "pointer",
        on: {
          "click": function($event) {
            _vm.editTextClick(('quotation_item_description' + quotation_item.id), quotation_item.description)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-alt"
      })]) : _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_description' + quotation_item.id)),
          expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_description'+quotation_item.id)"
        }],
        staticClass: "pointer",
        on: {
          "click": function($event) {
            _vm.editTextClick(('quotation_item_description' + quotation_item.id), quotation_item.description);
          }
        }
      }, [_c('pre', {
        staticClass: "pre-style"
      }, [_c('i', {
        staticClass: "fa fa-pencil-alt"
      }), _vm._v(" " + _vm._s(quotation_item.description))])]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "autosize",
          rawName: "v-autosize",
          value: (quotation_item.description),
          expression: "quotation_item.description"
        }, {
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == ('quotation_item_description' + quotation_item.id)),
          expression: "quotation.edit==('quotation_item_description'+quotation_item.id)"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.content_cache),
          expression: "content_cache"
        }],
        ref: ('quotation_item_description' + quotation_item.id),
        refInFor: true,
        staticClass: "full-input",
        attrs: {
          "rows": "3"
        },
        domProps: {
          "value": (_vm.content_cache)
        },
        on: {
          "blur": function($event) {
            _vm.quotation.edit = 'no';
            _vm.quotation.edit = 'no';
            quotation_item.description = _vm.content_cache;
            _vm.updateQuotationItem(quotation_item)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.content_cache = $event.target.value
          }
        }
      }, [_vm._v(_vm._s(quotation_item.description))])]), _vm._v(" "), _c('div', {
        staticClass: "quotation_column4"
      }, [_c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_number' + quotation_item.id)),
          expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_number'+quotation_item.id)"
        }],
        staticClass: "pointer mb0",
        on: {
          "click": function($event) {
            _vm.editTextClick(('quotation_item_number' + quotation_item.id), quotation_item.number)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-alt"
      }), _vm._v(" "), (_vm.checkEmpty(quotation_item.number)) ? _c('span', [_vm._v("0")]) : _c('span', [_vm._v(" " + _vm._s(quotation_item.number))])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == ('quotation_item_number' + quotation_item.id)),
          expression: "quotation.edit==('quotation_item_number'+quotation_item.id)"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.content_cache),
          expression: "content_cache"
        }],
        ref: ('quotation_item_number' + quotation_item.id),
        refInFor: true,
        staticClass: "full-input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (_vm.content_cache)
        },
        on: {
          "keypress": function($event) {
            _vm.isNumber($event)
          },
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            $event.target.blur()
          },
          "blur": function($event) {
            _vm.quotation.edit = 'no';
            quotation_item.number = _vm.content_cache;
            _vm.updateQuotationItem(quotation_item)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.content_cache = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "quotation_column5 hideIfNoShow"
      }, [_c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != ('quotation_item_price' + quotation_item.id)),
          expression: "quotation.edit=='no' || quotation.edit!=('quotation_item_price'+quotation_item.id)"
        }],
        staticClass: "pointer mb0",
        on: {
          "click": function($event) {
            _vm.editTextClick(('quotation_item_price' + quotation_item.id), quotation_item.price);
            _vm.changePriceDefault()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-alt"
      }), _vm._v(" "), (_vm.checkEmpty(quotation_item.price)) ? _c('span', [_vm._v("0")]) : _c('span', [_vm._v("$ " + _vm._s(quotation_item.price.toLocaleString()))])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.quotation.edit == ('quotation_item_price' + quotation_item.id)),
          expression: "quotation.edit==('quotation_item_price'+quotation_item.id)"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.content_cache),
          expression: "content_cache"
        }],
        ref: ('quotation_item_price' + quotation_item.id),
        refInFor: true,
        staticClass: "full-input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (_vm.content_cache)
        },
        on: {
          "keypress": function($event) {
            _vm.isNumber($event)
          },
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            $event.target.blur()
          },
          "blur": function($event) {
            _vm.quotation.edit = 'no';
            quotation_item.price = Number(_vm.content_cache);
            _vm.updateQuotationItem(quotation_item)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.content_cache = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "quotation_column6 hideIfNoShow"
      }, [_vm._v("\n\t                                  $ " + _vm._s((quotation_item.price * quotation_item.number).toLocaleString()) + "\n\t                                ")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default delete_quotation_item",
        on: {
          "click": function($event) {
            _vm.deleteQuotationItem(quotation_item, quotation_item_category)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times text-danger"
      })])])
    })), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-default btn-xs",
      on: {
        "click": function($event) {
          _vm.createNewQuotationItemToCategory(quotation_item_category)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])], 1)])
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.createQuotationItemCategory()
      }
    }
  }, [_vm._v("新增空白分類")])])])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("小計")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.totalPrice.toLocaleString()))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_tax'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_tax'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_tax', _vm.quotation.quotation_information.tax)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), (_vm.checkEmpty(_vm.quotation.quotation_information.tax)) ? _c('span', [_vm._v("稅金：無")]) : _c('span', [_vm._v("稅金：" + _vm._s(_vm.quotation.quotation_information.tax) + "%")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'quotation_information_tax'),
      expression: "quotation.edit=='quotation_information_tax'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "quotation_information_tax",
    staticClass: "medium-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.quotation_information.tax = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s((_vm.totalPriceAfterTax - _vm.totalPrice).toLocaleString()))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "quotation-color",
    style: ({
      'background-color': _vm.quotation['quotation_information']['background_color1'].hex,
      'color': _vm.quotation['quotation_information']['color1'].hex,
    }),
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "quotation-color text-right",
    style: ({
      'background-color': _vm.quotation['quotation_information']['background_color1'].hex,
      'color': _vm.quotation['quotation_information']['color1'].hex,
    })
  }, [_vm._v("總計")]), _vm._v(" "), _c('td', {
    staticClass: "quotation-color text-right",
    style: ({
      'background-color': _vm.quotation['quotation_information']['background_color1'].hex,
      'color': _vm.quotation['quotation_information']['color1'].hex,
    })
  }, [_vm._v("$ " + _vm._s(_vm.totalPriceAfterTax.toLocaleString()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content text-left"
  }, [(_vm.quotation.quotation_information.note == null || _vm.quotation.quotation_information.note == '') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_note'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_note'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_note', _vm.quotation.quotation_information.note)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" 報價單備註編輯區\n                  ")]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'no' || _vm.quotation.edit != 'quotation_information_note'),
      expression: "quotation.edit=='no' || quotation.edit!='quotation_information_note'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editTextClick('quotation_information_note', _vm.quotation.quotation_information.note)
      }
    }
  }, [_c('pre', {
    staticClass: "pre-style"
  }, [_c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.quotation.quotation_information.note))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.quotation.quotation_information.note),
      expression: "quotation.quotation_information.note"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.quotation.edit == 'quotation_information_note'),
      expression: "quotation.edit=='quotation_information_note'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    ref: "quotation_information_note",
    staticClass: "full-input",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "blur": function($event) {
        _vm.quotation.edit = 'no';
        _vm.quotation.edit = 'no';
        _vm.quotation.quotation_information.note = _vm.content_cache;
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.quotation.quotation_information.note))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("客戶簽章：_________________________________________")])]), _vm._v(" "), _c('div', {
    staticClass: "quotation-footer"
  })]) : _vm._e()])])])]), _vm._v(" "), _c('aside', {
    staticClass: "rightbar right-aside-toggle "
  }, [_c('div', {
    staticClass: "rightbar-container products_list_for_quotation"
  }, [_c('div', {
    staticClass: "chat-user-toolbar clearfix"
  }, [_c('div', {
    staticClass: "chat-user-search"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "關鍵字搜尋服務.."
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chat-user-container"
  }, [(_vm.products.length > 0) ? _c('div', {
    staticClass: "products-scroll-box"
  }, [_vm._l((_vm.orderedProductCategories), function(product_category, indexPc) {
    return _c('div', {
      staticClass: "category-box"
    }, [(_vm.filterProducts[indexPc].length > 0) ? _c('h3', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(product_category.name))]), _c('span', {
      staticClass: "pull-right online-counter"
    }, [_vm._v(_vm._s(_vm.filterProducts[indexPc].length) + " 項")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterProducts[indexPc]), function(product) {
      return (product.product_category_id == product_category.id) ? _c('ul', {
        staticClass: "chat-user-list"
      }, [_c('li', [_c('div', {
        attrs: {
          "data-trigger": "hover",
          "title": "Robertoortiz",
          "data-placement": "left"
        },
        on: {
          "click": function($event) {
            _vm.createQuotationItemFromProduct(product_category, product)
          }
        }
      }, [_vm._m(5, true), _vm._v(" "), _c('span', {
        staticClass: "chat-u-info"
      }, [_vm._v(_vm._s(product.name)), _c('cite', [_vm._v("$" + _vm._s(product.price))])])])])]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "category-box"
  }, [(_vm.noCategoryProducts[0].length > 0) ? _c('h3', {
    staticClass: "clearfix"
  }, [(_vm.product_categories.length > 0) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v("未分類")]) : _c('span', {
    staticClass: "pull-left"
  }, [_vm._v("所有服務")]), _c('span', {
    staticClass: "pull-right online-counter"
  }, [_vm._v(_vm._s(_vm.noCategoryProducts[0].length) + " 項")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.noCategoryProducts[0]), function(product) {
    return _c('ul', {
      staticClass: "chat-user-list"
    }, [_c('li', [_c('div', {
      attrs: {
        "data-trigger": "hover",
        "title": "Robertoortiz",
        "data-placement": "left"
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('span', {
      staticClass: "chat-u-info"
    }, [_vm._v(_vm._s(product.name)), _c('cite', [_vm._v("$" + _vm._s(product.price))])])])])])
  }), _vm._v(" "), (_vm.searchedProducts.length == 0) ? _c('h3', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("無符合的服務，請重新搜尋，或先到服務管理區建立此服務")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default margin-top-10",
    on: {
      "click": function($event) {
        _vm.GoProducts()
      }
    }
  }, [_vm._v("前往服務管理")])]) : _vm._e()], 2)], 2) : _c('div', {
    staticClass: "category-box"
  }, [(_vm.searchedProducts.length == 0) ? _c('h3', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("目前無任何可快速新增的服務，強烈建議您到服務管理區，將你的公司服務清單建立，未來將可快速增加報價單項目，大幅節省80%的報價時間唷！")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger margin-top-10",
    on: {
      "click": function($event) {
        _vm.GoProducts()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flash"
  }), _vm._v(" 馬上前往服務管理！")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.DeleteQuotationItemCategoryModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.DeleteQuotationItemCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.DeleteQuotationItemCategoryModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n                你確定要刪除此分類嗎？\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.DeleteQuotationItemCategoryModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('p', [_vm._v("你即將刪除「" + _vm._s(_vm.delete_quotation_item_category.name) + "」分類以及底下所有項目，此項步驟無法回覆。")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.deleteQuotationItemCategory(_vm.delete_quotation_item_category)
      }
    }
  }, [_vm._v("\n                  確定刪除\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.DeleteQuotationItemCategoryModal = false
      }
    }
  }, [_vm._v("\n                  取消\n                ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.SettingModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.SettingModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.SettingModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header text-center",
    staticStyle: {
      "display": "block"
    }
  }, [_c('span', [_vm._v("報價單編輯器，預設管理")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.SettingModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms",
    staticStyle: {
      "max-height": "500px",
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                在這裡，你可以變更報價單的基本設定，也可儲存為預設值，預設值會在你下次建立一個全新的報價單的時候帶入\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group color-picker"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("Logo上傳 (建議上傳寬度300px,高度介於50~100px的長型LOGO)")]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/quotations/update_company_logo/' + _vm.quotation.quotation_token,
      "headers": _vm.auth_token,
      "maxFileSizeInMB": 12
    },
    on: {
      "vdropzone-success": _vm.vsuccess
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("公司名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotation.sales_information['company_name']),
      expression: "quotation.sales_information['company_name']"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.quotation.sales_information['company_name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quotation.sales_information, 'company_name', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("標題顏色調整")]), _vm._v(" "), _c('span', {
    staticClass: "quotation-color pointer",
    style: ({
      'background-color': _vm.quotation['quotation_information']['background_color1'].hex,
      'color': _vm.quotation['quotation_information']['color1'].hex,
      'padding': '8px',
    }),
    on: {
      "click": function($event) {
        _vm.toggleColorPicker()
      }
    }
  }, [_vm._v("這是標題，請點我調整顏色試試看 "), _c('i', {
    staticClass: "fa fa-cog"
  })])]), _vm._v(" "), (_vm.showColorPicker) ? _c('div', {
    staticClass: "colorPickerBox card"
  }, [_c('div', {
    staticClass: "form-group color-picker"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("標題背景顏色")]), _vm._v(" "), _c('slider-picker', {
    model: {
      value: (_vm.quotation['quotation_information']['background_color1']),
      callback: function($$v) {
        _vm.$set(_vm.quotation['quotation_information'], 'background_color1', $$v)
      },
      expression: "quotation['quotation_information']['background_color1']"
    }
  }), _vm._v(" "), _c('material-picker', {
    model: {
      value: (_vm.quotation['quotation_information']['background_color1']),
      callback: function($$v) {
        _vm.$set(_vm.quotation['quotation_information'], 'background_color1', $$v)
      },
      expression: "quotation['quotation_information']['background_color1']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group color-picker"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("標題文字顏色")]), _vm._v(" "), _c('grayscale-picker', {
    model: {
      value: (_vm.quotation['quotation_information']['color1']),
      callback: function($$v) {
        _vm.$set(_vm.quotation['quotation_information'], 'color1', $$v)
      },
      expression: "quotation['quotation_information']['color1']"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.quotation.quotation_information.note),
      expression: "quotation.quotation_information.note"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.quotation.quotation_information.note),
      expression: "quotation.quotation_information.note"
    }],
    ref: "quotation_information_note",
    staticClass: "form-control",
    staticStyle: {
      "height": "auto !important"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.quotation.quotation_information.note)
    },
    on: {
      "blur": function($event) {
        _vm.UpdateQuotation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotation.quotation_information.note = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.quotation.quotation_information.note))]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "emailHelp"
    }
  }, [_vm._v("這將會放在報價單最底部")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.syncQuotationAll();
        _vm.saveDefault();
        _vm.SettingModal = false
      }
    }
  }, [_vm._v("\n                  儲存並設定為預設值\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.syncQuotationAll();
        _vm.SettingModal = false
      }
    }
  }, [_vm._v("\n                  僅儲存這份報價單\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.SettingModal = false
      }
    }
  }, [_vm._v("\n                  取消\n                ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-content"
  }, [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": require("../../assets/img/loading.gif")
    }
  }), _vm._v(" "), _c('h4', [_c('b', [_vm._v("轉存PDF中，請稍候～")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("報價日期")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("報價編號")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("回簽日期")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('b', [_vm._v("客戶資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('b', [_vm._v("業務資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "addon-icon"
  }, [_c('i', {
    staticClass: "zmdi zmdi-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "chat-avatar"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "chat-avatar"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b2d3f5c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quotation/QuotationView.vue
// module id = 669
// module chunks = 4